
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import MainNav from 'components/MainNav'
import Topbar from 'components/Topbar'
import {openHelp, openNotify, openProfileEditForm} from 'redux/modules/ui/modal/actions'
import {getNotifyNumber} from 'redux/modules/notifications/selectors'
import {fetchNotificationsNumber} from 'redux/modules/notifications/actions'
import {getSitesWithMerchants} from 'redux/modules/sites/selectors'
import Logo from 'components/Logo'
import Sidebar from 'components/Sidebar'
import ErrorPage from 'views/NotFoundView'
import {push as pushState} from 'react-router-redux'
import {
  selectSite,
  logoutUser,
  saveCrossSiteSites
} from 'redux/modules/currentUser/actions'
import {
  handleError
} from 'redux/modules/error/actions'
import {
  getCurrentSite,
  getCurrentUser,
  getCurrentMerchant,
  getAggregatedSites,
  isAdminUser,
  isDemoUser
} from 'redux/modules/currentUser/selectors'

export class SidebarContainer extends React.Component {
  static propTypes = {
    aggregatedSites: PropTypes.array,
    currentMerchant: PropTypes.object,
    currentSite: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    currentUser: PropTypes.object,
    isDemoUser: PropTypes.bool,
    isAdminUser: PropTypes.bool,
    logoutUser: PropTypes.func,
    openHelp: PropTypes.func,
    openNotify: PropTypes.func,
    notifyNumber: PropTypes.number,
    fetchNotificationsNumber: PropTypes.func,
    globalError: PropTypes.object,
    handleError: PropTypes.func,
    openProfileEditForm: PropTypes.func,
    pushState: PropTypes.func.isRequired,
    saveCrossSiteSites: PropTypes.func,
    selectSite: PropTypes.func,
    sites: PropTypes.array
  }
  componentDidMount() {
    const {fetchNotificationsNumber} = this.props
    fetchNotificationsNumber()
  }
  render() {
    const {openHelp} = this.props

    return (
      <div className='sidebar-container'>
        {this.renderTopbar()}
        <div className='sidebar-container_sidebar'>
          <Sidebar>
            <MainNav openHelp={openHelp} className='sidebar_main-nav' />
          </Sidebar>
        </div>
        <div className='sidebar-container_content'>
          {this.renderContent()}
        </div>
      </div>
    )
  }

  renderTopbar() {
    const {
      selectSite,
      aggregatedSites,
      logoutUser,
      openProfileEditForm,
      sites,
      currentSite,
      currentUser,
      currentMerchant,
      isDemoUser,
      openNotify,
      notifyNumber,
      isAdminUser
    } = this.props

    return (
      <div className='sidebar-container_topbar'>
        <Logo
          link
          className='sidebar-container_logo'
          to={isDemoUser ? __WWW_URL__ : null}
          text={isDemoUser ? 'back to divvit.com' : null}
        />
        <Topbar
          onSelectSite={selectSite}
          onLogout={logoutUser}
          onEditProfile={openProfileEditForm}
          onEditSites={this.onChangeCrossSiteSites}
          sites={sites}
          currentSite={currentSite}
          selectedSites={aggregatedSites}
          user={currentUser}
          adminUser={isAdminUser}
          freeMerchant={!currentMerchant.paid}
          openNotify={openNotify}
          notifyNumber={notifyNumber}
          demoUser={isDemoUser}
        />
      </div>
    )
  }

  renderContent() {
    const {globalError} = this.props

    if (globalError) {
      return <ErrorPage status={500} />
    }

    return this.props.children
  }

  onChangeCrossSiteSites = sites => {
    const {saveCrossSiteSites, pushState} = this.props
    saveCrossSiteSites(sites)
    pushState('/cross-site')
  }

  componentDidCatch(error, info) {
    const {handleError} = this.props
    handleError(error)
  }
}

export default connect((state, props) => {
  const currentUser = getCurrentUser(state)
  const notifyNumber = getNotifyNumber(state)
  return {
    currentMerchant: getCurrentMerchant(state),
    notifyNumber,
    aggregatedSites: getAggregatedSites(state, true),
    sites: getSitesWithMerchants(state),
    currentSite: getCurrentSite(state),
    isDemoUser: isDemoUser(state),
    currentUser,
    isAdminUser: isAdminUser(state),
    globalError: state.error.globalError
  }
}, {
  openHelp,
  openNotify,
  fetchNotificationsNumber,
  selectSite,
  logoutUser,
  openProfileEditForm,
  saveCrossSiteSites,
  handleError,
  pushState
}, null, {pure: false})(SidebarContainer)



// WEBPACK FOOTER //
// ./client/containers/SidebarContainer/index.js